import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';
import { Button } from 'components';
import styles from "./ProfileButton.module.scss"
export default function ProfileButton({ onLoginClick, onOpenProfile }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [imgOk, setImgOk] = useState(true);

  if (user) {
    const avatar = user.avatar || user?.profile?.photo || null;
    const altText = user.username || user?.profile?.name || user?.name || 'avatar';
    // If avatar exists and loaded successfully, render the image itself as a clickable element.
    if (avatar && imgOk) {
      return (
        <div className={styles.container}>
          <div className={styles.bonus}>
            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="size-[24px]" data-sentry-element="CashbackIcon" data-sentry-source-file="balance-badge.tsx"><path d="M4 9.63506C3.99998 9.00721 4.4738 8.75273 5.0583 9.06668L10.3493 11.9085C10.9338 12.2225 11.4077 12.9859 11.4077 13.6138L11.4079 19.2971C11.4079 19.925 10.9341 20.1795 10.3496 19.8655L5.05858 17.0237C4.47407 16.7097 4.00022 15.9463 4.00019 15.3184L4 9.63506Z" fill="#FED647"></path><path d="M5.70683 8.21372C5.12231 7.89981 5.12231 7.39086 5.70683 7.07696L10.998 4.23543C11.5826 3.92152 12.5303 3.92152 13.1148 4.23543L18.406 7.07696C18.9905 7.39086 18.9905 7.89981 18.406 8.21372L13.1148 11.0552C12.5303 11.3691 11.5826 11.3692 10.998 11.0552L5.70683 8.21372Z" fill="#FED647"></path><path d="M12.5923 13.3299C12.5923 12.702 13.0662 11.9386 13.6507 11.6246L18.9417 8.78277C19.5262 8.46883 20 8.7233 20 9.35115L19.9998 15.0345C19.9998 15.6624 19.5259 16.4258 18.9414 16.7398L13.6504 19.5816C13.0659 19.8956 12.5921 19.6411 12.5921 19.0132L12.5923 13.3299Z" fill="#d8aa02ff"></path></svg>
            <div className={styles.bonusText}>
              <span className={styles.points}>{user?.cashback_balance ?? 0}</span>
              <span className={styles.symbol}>&#x20c0;</span>
            </div>
          </div>
          <div className={styles.avatar}>
            <img
              src={avatar}
              alt={altText}
              loading="lazy"
              decoding="async"
              onError={() => setImgOk(false)}
              onClick={() => {
                if (onOpenProfile) onOpenProfile()
                else onOpenProfile()
              }}
              role="button"
              aria-label="Профиль"
            />
          </div>
        </div>

      );
    }

    // Fallback: show the button with text when there's no avatar or image failed to load
    return (
      <div className={styles.container}>
        <div className={styles.bonus}>
          <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="size-[24px]" data-sentry-element="CashbackIcon" data-sentry-source-file="balance-badge.tsx"><path d="M4 9.63506C3.99998 9.00721 4.4738 8.75273 5.0583 9.06668L10.3493 11.9085C10.9338 12.2225 11.4077 12.9859 11.4077 13.6138L11.4079 19.2971C11.4079 19.925 10.9341 20.1795 10.3496 19.8655L5.05858 17.0237C4.47407 16.7097 4.00022 15.9463 4.00019 15.3184L4 9.63506Z" fill="#FED647"></path><path d="M5.70683 8.21372C5.12231 7.89981 5.12231 7.39086 5.70683 7.07696L10.998 4.23543C11.5826 3.92152 12.5303 3.92152 13.1148 4.23543L18.406 7.07696C18.9905 7.39086 18.9905 7.89981 18.406 8.21372L13.1148 11.0552C12.5303 11.3691 11.5826 11.3692 10.998 11.0552L5.70683 8.21372Z" fill="#FED647"></path><path d="M12.5923 13.3299C12.5923 12.702 13.0662 11.9386 13.6507 11.6246L18.9417 8.78277C19.5262 8.46883 20 8.7233 20 9.35115L19.9998 15.0345C19.9998 15.6624 19.5259 16.4258 18.9414 16.7398L13.6504 19.5816C13.0659 19.8956 12.5921 19.6411 12.5921 19.0132L12.5923 13.3299Z" fill="#d8aa02ff"></path></svg>
          <div className={styles.bonusText}>
            <span className={styles.points}>{user.profile?.bonus_points ?? 0}</span>
            <span className={styles.symbol}>&#8384;</span>
          </div>
        </div>
        <Button className={styles.btn_modal_close_prof} style={{ marginTop: '0px !important' }} onClick={() => onOpenProfile()}>
          <span>U</span>
        </Button>
      </div>
    );
  }

  return <Button className="auth__btn" onClick={onLoginClick}>Войти</Button>;
}
